  let questionses = document.querySelectorAll(".questionses");
  questionses.forEach(questionses => {
    questionses.addEventListener("click", event => {
      const active = document.querySelector(".questionses.active");
      if (active && active !== questionses) {
        active.classList.toggle("active");
        active.nextElementSibling.style.maxHeight = 0;
      }
      questionses.classList.toggle("active");
      const answerses = questionses.nextElementSibling;
      if (questionses.classList.contains("active")) {
        answerses.style.maxHeight = answerses.scrollHeight + "px";
      } else {
        answerses.style.maxHeight = 0;
      }
    })
  })



$('.usp-block-slider').slick({
  centerMode: false,
  centerPadding: '00px',
  slidesToShow: 1,
  infinite:true,  
  rows: 0,
  arrows: true,
  dots: false,
  autoplay:false,
  autoplaySpeed:2500,  
});